import { render, staticRenderFns } from "./NewTrip.vue?vue&type=template&id=d0dc923c&"
import script from "./NewTrip.vue?vue&type=script&lang=js&"
export * from "./NewTrip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports